// @ts-strict

import { Component, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { IChosenSortValue } from '@app/core/models/core-models';
import { CampaignsListService } from '@app/core/services/campaigns-list/campaigns-list.service';

@Component({
  selector: 'app-sort-dropdown',
  templateUrl: './sort-dropdown.component.html',
  styleUrls: ['./sort-dropdown.component.scss']
})
export class SortDropdownComponent implements OnChanges {
  @Input() sortValues?: IChosenSortValue[];
  @Input() sortDropdownClass?: string;
  @Input() onlyNumbers?: boolean;
  @Input() choosenSortValue?: IChosenSortValue;
  @Input() alternativeLook?: boolean;
  @Input() tolltipPresent?: boolean;
  @Input() search = false;
  @Input() mobileMode = false;
  @Input() mobileTemplate = 'default';
  @Input() disabled = false;

  @Output() emitChosenValue = new EventEmitter<IChosenSortValue>();

  public sortDropdownActive = false;
  public filteredValues?: IChosenSortValue[];

  get biggerButtonStyle(): boolean {
    return this.sortDropdownClass === 'biggerButton';
  }

  constructor(private campaignsList: CampaignsListService) {}

  ngOnChanges(): void {
    if (!this.choosenSortValue) {
      this.choosenSortValue = this.sortValues?.[0];
    }
  }

  public dropdownMenu(): void {
    this.sortDropdownActive = !this.sortDropdownActive;
  }

  public closeDropdown(): void {
    this.sortDropdownActive = false;
  }

  public getSortValue(element: IChosenSortValue): void {
    this.choosenSortValue = element;
    this.emitChosenValue.emit(element);
    this.dropdownMenu();
  }

  public inputHandler(inputValue: string): void {
    this.filteredValues = this.sortValues?.filter(x => x.name?.toLowerCase().includes(inputValue.toLowerCase()));
  }
}
